import { Injectable } from "@angular/core";
import { MapperInterface } from "./mapper-inteface";
import { DifferenzaDTO } from "@dto/differenzaDTO";
import { DifferenzaVO } from "@vo/differenzaVO";
import { TipoDifferenzaEnum } from "../enum/tipo-differenza.enumDTO";

@Injectable({
  providedIn: "root",
})
export class MapperDifferenza
  implements MapperInterface<DifferenzaDTO, DifferenzaVO> {
  constructor() { }
  convertVoToDto(vo: DifferenzaVO): DifferenzaDTO {
    if (vo != null) {
      const dto = new DifferenzaDTO();
      dto.campo = vo.campo;
      dto.valoreFinale = vo.valoreFinale;
      dto.valoreIniziale = vo.valoreIniziale;
      dto.tipoDifferenza = vo.tipoDifferenza;

      return dto;
    } else {
      return null;
    }
  }

  convertDtoToVo(dto: DifferenzaDTO): DifferenzaVO {
    if (dto != null) {
      const vo = new DifferenzaDTO();
      vo.dettaglioCampo = dto.dettaglioCampo;

      vo.campo = dto.campo;

      vo.valoreFinale = dto.valoreFinale;
      vo.valoreIniziale = dto.valoreIniziale;
      vo.tipoDifferenza = dto.tipoDifferenza;
      if (dto.nomeAllegato !== null) {
        vo.nomeAllegato = dto.nomeAllegato;
      }
      if (dto.dettaglioCampo) {
        vo.campo = dto.dettaglioCampo;
      }
      return vo;
    } else {
      return null;
    }
  }
  convertListVoToDto(e: DifferenzaVO[]): DifferenzaDTO[] {
    if (e != null) {
      return e.map((vo) => this.convertVoToDto(vo));
    } else {
      return null;
    }
  }
  convertListDtoToVo(t: DifferenzaDTO[]): DifferenzaVO[] {
    if (t != null) {
      return t.map((vo) => this.convertDtoToVo(vo));
    } else {
      return null;
    }
  }
}
